import P from 'bluebird'

class Spinner {
    constructor() {
        var div = document.createElement("div")
        div.id = "spinner"
        div.style.display = 'none'
        div.style.zIndex = 99999
        div.innerHTML = `<svg width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ring" data-reactid=".0.1.0"><rect x="0" y="0" width="100" height="100" fill="none" class="bk" data-reactid=".0.1.0.0"></rect><circle cx="50" cy="50" r="40" stroke-dasharray="163.36281798666926 87.9645943005142" stroke="#28619e" fill="none" stroke-width="20" data-reactid=".0.1.0.1"></circle></svg>`
        document.addEventListener("DOMContentLoaded", () => {
            document.body.appendChild(div)
        })
    }

    start() {
        var spinner = document.getElementById('spinner')
        spinner.style.display = 'block'
    }

    stop() {
        var spinner = document.getElementById('spinner')
        spinner.style.display = 'none'
    }

    delay(ms) {
        this.start()
        return P.delay(ms).then(()=>{
            this.stop()
        })
    }
}

window.Spinner = new Spinner()

export default window.Spinner